<template>
  <section class="hero">
    <div class="hero__inner">
      <div class="hero__left">
        <h1>{{ country.name }}</h1>
        <img :src="flagUrl" class="flag" />
      </div>
      <button class="country-switch" @click="$emit('back')">
        Select other country →
      </button>
    </div>
  </section>
</template>

<script>
export default {
  props: ['country'],
  computed: {
    flagUrl() {
      // Ha SVG-t használsz, írd át .svg-re
      try {
        return require(`../../assets/img/we-circular/Contacts_Zászlók/${this.country.id}.svg`)
      } catch (e) {
        return '' // fallback ha nincs kép
      }
    }
  }
}
</script>

<style scoped>
.hero {
  background: #004444; /* javítva */
  padding: 30px 40px;
  color: #ffffff;
}

.hero__inner {
  max-width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hero__left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.hero h1 {
  font-size: 40px;
  color: #ffffff;
}

.flag {
  width: 50px;
}

.country-switch {
  background: #18baa8; /* javítva */
  border: none;
  padding: 12px 18px;
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
}
</style>
